import React from "react";
import { useSelector, useDispatch } from "react-redux";

// Material UI
import { makeStyles, createStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Drawer from "@material-ui/core/Drawer";
import { Palette } from "../../AppConfig";
import * as APP from "../../redux_store/appState";

import SpecToolAccordian from "./SpecToolAccordian";
import SpecDecks from "./decks/SpecDecks";
import SpecLouvre from "./louvres/SpecLouvres";

// BabyloneJS data store

const toolDrawerWidth = 800;
const toolDrawerClosedWidth = 390;
const toolDrawerHideWidth = 0;

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            display: "flex",
            overflowX: "hidden",
        },
        drawer: {
            width: toolDrawerWidth,
            "-webkit-user-drag": "none",
            "-webkit-user-select": "none",
            flexShrink: "0",
            whiteSpace: "nowrap",
            overflowX: "hidden",
        },
        drawerPaper: {
            "-webkit-user-drag": "none",
            "-webkit-user-select": "none",
            overflowX: "hidden",
            backdropFilter: "blur(4px)",
        },

        toolDrawerOpen: {
            // backgroundColor: "rgba(242,245,251, 0.5)",
            color: Palette.Control.DarkGrey,
            backgroundColor: window.FIELDERS ? "#dde5ecdb" : "#F4F4F4",

            "-webkit-user-drag": "none",
            "-webkit-user-select": "none",
            width: toolDrawerWidth,
            // transition: theme.transitions.create('width', {
            //   easing: theme.transitions.easing.sharp,
            //   duration: theme.transitions.duration.enteringScreen,
            // }),
        },
        toolDrawerClose: {
            "-webkit-user-drag": "none",
            "-webkit-user-select": "none",
            color: Palette.Control.DarkGrey,
            backgroundColor: window.FIELDERS ? "#dde5ecdb" : "#F4F4F4",
            // transition: theme.transitions.create('width', {
            //   easing: theme.transitions.easing.sharp,
            //   duration: theme.transitions.duration.leavingScreen,
            // }),
            overflowX: "hidden",
            // width: theme.spacing(  7 + 1 ),
            // [theme.breakpoints.up('sm')]: {
            //   width: theme.spacing(  7 + 1 ),
            // },
            width: toolDrawerClosedWidth,
        },
        toolDrawerHide: {
            "-webkit-user-drag": "none",
            "-webkit-user-select": "none",
            color: Palette.Control.DarkGrey,
            backgroundColor: window.FIELDERS ? "#dde5ecdb" : "#F4F4F4",
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: "hidden",
            // width: theme.spacing(  7 + 1 ),
            // [theme.breakpoints.up('sm')]: {
            //   width: theme.spacing(  7 + 1 ),
            // },
            width: toolDrawerHideWidth,
            display: "none",
        },
        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0 8px",
            minHeight: "48px",
            ...theme.mixins.toolbar,
        },
        toolMenuText: {
            color: "white",
            textAlign: "right",
        },
        toolMenuOn: {
            color: "orange",
            textShadow: "0px 0px 7px rgba(107,107,107,0.89)",
        },
        toolMenuOff: {
            color: "white",
            textShadow: "0px 0px 7px rgba(107,107,107,0.89)",
        },
        toolListItem: {
            paddingRight: "0px",
            minWidth: toolDrawerWidth,
        },
        arrow_container: {
            top: "48px",
            position: "sticky",
            zIndex: "100",
            width: "100%",
            textAlign: "right",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
        },
        listItemText: {
            color: "white",
            position: "absolute",
            marginTop: "15px",
        },
        listItemTextRoot: {
            fontSize: "37%",
        },
        dragger: {
            width: "3px",
            cursor: "ew-resize",
            padding: "4px 0 0",
            borderTop: "1px solid #ddd",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: "2",
            backgroundColor: "#c7ccd0",
            "-webkit-user-drag": "none",
            "&:hover": {
                backgroundColor: "#a7aca0",
            },
        },
    })
);

export default function SpecificationToolDrawer(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);

    const TOOL_DRAWER_HIDE = app.designer[APP.TOOL_DRAWER_HIDE];
    const [isResizing, setIsResizing] = React.useState(false);
    const [lastDownX, setLastDownX] = React.useState(0);
    const [newWidth, setNewWidth] = React.useState({});

    const handleMousedown = (e) => {
        setLastDownX(e.clientX);
        setIsResizing(true);
        window.isResizing = true;
    };

    React.useEffect(() => {
        const setFromEvent = (e) => {
            if (!window.isResizing) return;

            let offsetRight = document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
            let minWidth = 330;
            let maxWidth = document.body.offsetWidth - 80;

            if (offsetRight < minWidth) {
                if (offsetRight < 100) {
                    offsetRight = minWidth;
                } else {
                    offsetRight = minWidth;
                }
            }
            if (offsetRight > maxWidth) {
                offsetRight = maxWidth;
            }

            setNewWidth({ width: offsetRight });
            window.tool_drawer_width = offsetRight; // not a fan of using window global, but was taking too long to work out how to pass to handleMouseUo below.
        };

        window.addEventListener("mousemove", setFromEvent);

        return () => {
            window.removeEventListener("mousemove", setFromEvent);
        };
    }, []);

    React.useEffect(() => {
        const handleMouseUo = (e) => {
            window.isResizing = false;
            if (window.tool_drawer_width) dispatch(APP.updateDesigner(APP.TOOL_DRAWER_WIDTH, window.tool_drawer_width));
        };

        window.addEventListener("mouseup", handleMouseUo);

        return () => {
            window.removeEventListener("mouseup", handleMouseUo);
        };
    }, []);

    return (
        <Drawer
            variant="permanent"
            anchor="right"
            className={classNames(classes.drawer, {
                [classes.toolDrawerClose]: !TOOL_DRAWER_HIDE,
                [classes.toolDrawerHide]: TOOL_DRAWER_HIDE,
            })}
            classes={{
                paper: classNames(classes.drawerPaper, {
                    [classes.toolDrawerClose]: !TOOL_DRAWER_HIDE,
                    [classes.toolDrawerHide]: TOOL_DRAWER_HIDE,
                }),
            }}
            PaperProps={{ style: newWidth }}
            open={!TOOL_DRAWER_HIDE}
        >
            <>
                <div
                    id="dragger"
                    onMouseDown={(event) => {
                        handleMousedown(event);
                    }}
                    className={classes.dragger}
                />
                <div
                    style={{
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div className={classes.toolbar} style={{ minHeight: "84px" }} />
                    {job?.DesignParameters?.DeckMode === 1 && (
                        <SpecDecks
                            width={newWidth}
                            openMessageBox={props.openMessageBox}
                            setEngineeringStatus={props.setEngineeringStatus}
                            setEngineeringLoading={props.setEngineeringLoading}
                            engineeringLoading={props.engineeringLoading}
                        />
                    )}
                    {job?.DesignParameters?.LouvreMode === 1 && (
                        <SpecLouvre width={newWidth} openMessageBox={props.openMessageBox} />
                    )}
                    {job?.DesignParameters?.DeckMode !== 1 && job?.DesignParameters?.LouvreMode !== 1 && (
                        <SpecToolAccordian
                            width={newWidth}
                            openMessageBox={props.openMessageBox}
                            setEngineeringStatus={props.setEngineeringStatus}
                            setEngineeringLoading={props.setEngineeringLoading}
                            engineeringLoading={props.engineeringLoading}
                        />
                    )}
                </div>
            </>
        </Drawer>
    );
}
